import {BookingType} from "../../../models/payment/booking-type";
import {BusinessCaseInformation} from "./business-case-information";
import {KassenvorgangShape} from "../../../_shared/calculation/kassenvorgang-shape";

export class ClosingModel {
  summary: { [p: number]: number } = {};
  businessCaseTypes: { [key: number]: number } = {};

  get(bookingType: BookingType): number {
    return this.summary[bookingType] ?? 0;
  }

  actual: number | null = null;

  add(amount: number) {
    this.actual = Math.max((this.actual ?? this.get(BookingType.Cash)) + amount, 0);
  }

  private _skimming_difference: number | null = null;
  get skimming_difference(): number | null {
    return this._skimming_difference;
  }

  set skimming_difference(value: number | null) {
    this._skimming_difference = value == 0 ? null : value;
  }

  private _skimming_result: number | null = null;
  get skimming_result(): number | null {
    return this._skimming_result;
  }

  set skimming_result(value: number | null) {
    this._skimming_result = value;
  }

  comment: string = "";

  reset_closing_values() {
    this.actual = null;
    this.skimming_difference = null;
    this.skimming_result = null;
    this.comment = "";
  }

  validate(): string | undefined {
    // todo niko: check if this is correct
    //if ((this.actual ?? this.summary[BookingType.Cash] ?? 0).toCurrencyFraction() < 0) {
    //  return "Der Kassenbestand darf nicht negativ sein.";
    //}

    if ((this.skimming_result ?? ((this.actual ?? this.summary[BookingType.Cash] ?? 0) - (this.skimming_difference ?? 0))).toCurrencyFraction() < 0) {
      return "Der Kassenbestand darf nicht negativ sein.";
    }

    return undefined;
  }

  toBusinessCaseInformation(): BusinessCaseInformation[] {
    let actual = (this.actual ?? this.summary[BookingType.Cash] ?? 0).toCurrencyFraction();
    let skimming_result = this.skimming_result ?? ((this.actual ?? this.summary[BookingType.Cash] ?? 0) - (this.skimming_difference ?? 0)).toCurrencyFraction();

    let bcs: BusinessCaseInformation[] = [];

    // Both postings are minted by the shared factories (`KassenvorgangShape`), so the assistant, the direct
    // close, the register and the server agree on the stored shape (#820: the signed money on `amount`,
    // `quantity` +1), on the transit's qualifier (#820: Abschöpfung out, Einlage in) and on the difference's key
    // (#822: a surplus at the standard rate, a shortfall not taxable). The server decides all three from the
    // sign whatever arrives.
    // `difference` is Soll − Ist here, so the signed money is its negation: positive = surplus.
    let difference = ((this.summary[BookingType.Cash] ?? 0) - actual).toCurrencyFraction();
    if (difference != 0) {
      bcs.push(KassenvorgangShape.kassendifferenz(-difference, this.comment ? this.comment : null));
    }

    // Endbestand − Ist: negative for cash taken out, positive for cash put in.
    let skimming = (skimming_result - actual).toCurrencyFraction();
    if (skimming != 0) {
      bcs.push(KassenvorgangShape.geldtransit(skimming));
    }

    return bcs;
  }

  success: boolean = false;
}
